<template>
	<div>
		<!--header-->
		<TopAppBar
			leftBtnMode="arrow_back"
			:rightBtnMode="rightBtnMode"
			:title= "brandName"
			:leftBtnMethod="confirmOnCancel"
			:rightBtnMethod="rightBtnMethod"
      :hideCategory="false"
			:staticMode="true"
		>
		</TopAppBar>
	<div class="d-flex h-full flex-column">
			<TopAppBarDrawer></TopAppBarDrawer>
			<main class="main-wrapper flex-grow-1">
							<div class="d-flex align-items-center bg-white">
								<div class="t-headline13 t-color-headlineBlack pda-14 t-center font-m flex-grow-1 fix-header-title d-flex justify-content-center align-items-center">
									{{this.$t('1348')}}
								</div>
							</div>
							<div class="divider"></div>
							<!-- subtabs -->
							<div class="container container--narrow mgt-50">
									<div class="t-headline11 l-spacing72 font-m">{{this.$t('1349')}}</div>
									<div class="t-body1 t-color-bodyGrayA font-r l-spacing48 mgt-8">{{$t('1350')}}</div>
									<div class="mgt-50 t-body1 t-color-bodyGrayA font-r l-spacing48">{{ $t('1351') }}</div>
									<div class="mgt-4 t-body1 font-r l-spacing48">{{licenseName}}</div>
									<div class="divider mgt-16"></div>
									<form @submit.prevent="" novalidate>
									<div class="mgt-24">
													<label class="mdc-text-field mdc-text-field--outlined mdc-text-field--with-trailing-icon w-full h-46 "
															data-mdc-auto-init="MDCTextField"
															:class="submitState && validateIssueDate ? 'mdc-text-field--invalid invalid-icon-data' : 'valid-icon-data textFieldVal'"

															id="issueFieldEl"
														>
													<span class="mdc-notched-outline">
														<span class="mdc-notched-outline__leading"></span>
														<span class="mdc-notched-outline__notch">
															<span class="mdc-floating-label" id="password-message">{{$t('1319')}}</span>
														</span>
														<span class="mdc-notched-outline__trailing"></span>
													</span>
													<input class="mdc-text-field__input" type="text"
															v-model="issueValue"
															v-validate="'required|min:8|max:8'"
															ref="issueDate"
															id="issueDate"
															name="issueDate"
															pattern="[0-9]"
															@keyup="checkNumber"
															maxlength="8"
													/>
													<i class="material-icons mdc-text-field__icon mdc-text-field__icon--trailing d-block"
																	role="button"
																	:class="issueIcon === 'check' ? 'check_show' : ''"
																	>{{issueIcon}}</i>
													</label>
													<div class="mdc-text-field-helper-line d-block">
														<div class="mdc-text-field-helper-text mdc-text-field-helper-text--persistent t-helper mdc-text-field-helper-text--validation-msg font-r ">
															{{$t('1329')}}
														</div>
													</div>
									</div>
									<div class="mgt-16" :style="useValidity? 'display:block;' : 'display:none;'">
													<label class="mdc-text-field mdc-text-field--outlined mdc-text-field--with-trailing-icon w-full h-46"
														data-mdc-auto-init="MDCTextField"
														:class="submitState && validateExpiryDate ? 'mdc-text-field--invalid invalid-icon-data' : 'valid-icon-data textFieldVal'"
															id="expiryFieldEl"

													>
													<span class="mdc-notched-outline">
																	<span class="mdc-notched-outline__leading" :style="submitState && validateExpiryDate ? 'border-color:var(--Textfeilderror)!important;':''"></span>
																	<span class="mdc-notched-outline__notch" :style="submitState && validateExpiryDate ? 'border-color:var(--Textfeilderror)!important;':''">
																					<span class="mdc-floating-label" id="password-message">{{$t('1345')}}</span>
																	</span>
																	<span class="mdc-notched-outline__trailing" :style="submitState && validateExpiryDate ? 'border-color:var(--Textfeilderror)!important;':''"></span>
													</span>
													<input class="mdc-text-field__input" type="text"
															v-model="expiryValue"
															v-validate="'required|min:8|max:8'"
															ref="expiryDate"
															id="expiryDate"
															name="expiryDate"
															pattern="[0-9]"
															@keyup="checkNumber"
															maxlength="8"
													/>
													<i class="material-icons mdc-text-field__icon mdc-text-field__icon--trailing"
																	role="button"
																	:class="expiryIcon === 'check' ? 'check_show' : ''"
																	>{{expiryIcon}}</i>
													</label>
													<div class="mdc-text-field-helper-line d-block">
																	<div class="mdc-text-field-helper-text mdc-text-field-helper-text--persistent t-helper mdc-text-field-helper-text--validation-msg font-r ">
																					{{$t('1330')}}
																	</div>
													</div>
									</div>
									<div class="divider mgt-16 mgb-16"></div>
									<div class="t-body1 t-color-bodyGrayA font-r l-spacing48">{{ $t('1352') }}{{ $t('1353') }}</div>
									<input
										type="file"
										id="commentFileUpload"
										:accept="allowExt()"
										@change="uploadFile"
										class="d-none"
                            		/>
									<!-- <div v-if="image == null" @click="selectImage" class="mgt-24 imageAttachedPlaceHolder d-inline-flex justify-content-center align-items-center b-radius4 bg-contentBlueInactive flex-column">
										<div>
											<i class="material-icons w-28 h-28 font-28 t-color-contentBlueMedium">add</i>
										</div>
										<div class="t-helper t-color-contentBlueMedium">{{ $t('1323') }}</div>
									</div>
									<div v-if="image != null" class="mgt-24 imageAttachedPlaceHolder d-inline-flex justify-content-center align-items-center b-radius4 bg-contentBlueInactive flex-column square-image">
											<img :src="image.resourceUri" @click="selectImage" alt="">
									</div> -->

									<div v-if="image == null" tabindex="0" @click="openFileUpload(true,true)" @keypress="openFileUpload(true,true)" class="mgt-24 imageAttachedPlaceHolder d-inline-flex justify-content-center align-items-center b-radius4 bg-contentBlueInactive flex-column">
										<div><i class="material-icons w-28 h-28 font-28 t-color-contentBlueMedium">add</i> </div>
										<div class="t-helper t-color-contentBlueMedium">{{ $t('1323') }}</div>
									</div>

									<div v-if="image != null" class="mgt-24 imageAttachedPlaceHolder d-inline-flex justify-content-center align-items-center b-radius4 bg-contentBlueInactive flex-column square-image">
										<img  :src="image.resourceUri" tabindex="0" @click="openFileUpload(true,true)" @keypress="openFileUpload(true,true)" style="border: 1px solid var(--Divider);">
										<span tabindex="0" @click.prevent="removeLiencesImage" @keypress.prevent="removeLiencesImage" class="remove-img remove-image-new position-absolute t-color-white"><img src="/images/close.svg" style="width: 20px;height: 20px" /></span>
									</div>

									<div class="mgt-50 mgb-50">
											<button class="mdc-button mdc-button--raised bg-mainBtn t-color-mainBtnText mgr-8" @click="validateForm()" @keypress="validateForm()" tabindex="0">
												<div class="mdc-button__ripple"></div>
												<span class="mdc-button__label t-body2 font-r">{{$t('1354')}}</span>
											</button>
											<button class="mdc-button bg-white t-color-secondaryBtnText" @click="confirmOnCancel()" @keypress="confirmOnCancel()" tabindex="0">
												<div class="mdc-button__ripple"></div>
												<span class="mdc-button__label t-body2 font-r">{{$t('1355')}}</span>
											</button>
									</div>
							</form>
					</div>
			</main>
		</div>
	</div>
</template>

<script>
// Components/Mixin/Extend/API define
import TopAppBar from '@/components/TopAppBar.vue';
import {topAppBarMixin} from '@/mixins/topAppBar.js';
import {joinMixin} from '@/mixins/join.js';
import {MDCTextField} from '@material/textfield';
import {MDCRipple} from '@material/ripple';
import TopAppBarDrawer from "../TopAppBarDrawer.vue";
import httpService from "@/api/httpService.js";
import licenseApi from "@/api/licenseApi.js";
import memberApi from "@/api/memberApi.js";

export default {
	components: {
		TopAppBar,
		TopAppBarDrawer
	},

	mixins: [topAppBarMixin, joinMixin],

	data() {
		return {
			issueIcon: '',
			expiryIcon: '',
			issueField: null,
			imagePreview: null,
			id: null,
			memberId: null,
			memberName: null,
			licenseId: null,
			licenseName: null,
			issueValue: null,
			expiryValue: null,
			image: null,
			submitState: null,
			useValidity: true,
			tempImage: null,
			brandName: localStorage.getItem('brandName'),
			uploadTypeImg: true,
			type: true
		};
	},

	mounted() {
		// setting topbar
		this.setTopAppBarCloseOnly();

		// setting for material UI
		this.setMaterialUi();

		// get member id
		this.getMemberId();
		let tempImageStore =JSON.parse(localStorage.getItem("licenseImage"));
		this.tempImage =tempImageStore && tempImageStore.file ? tempImageStore.file: null;
	},

	methods: {
		confirmOnCancel(){
			this.$confirm({
				title: this.$t("1339"),
				content:this.$t("1340"),
				accept: this.$t("1342"),
				cancel: this.$t("1341"),
			})
			.then(() => {
				localStorage.removeItem("licenseImage");
				this.$router.push('/viewLicense');
			})
			.catch(() => {});
		},
		setMaterialUi() {
			const buttonRipple = [].map.call(document.querySelectorAll('.mdc-button'), function(el) {
				let button = new MDCRipple.attachTo(el);
				return button;
			});

			this.issueField = new MDCTextField(document.querySelector('#issueFieldEl'));
			this.issueField.useNativeValidation = false;
			this.issueDate = '';
			this.issueField.value = this.issueDate;

			this.expiryField = new MDCTextField(document.querySelector('#expiryFieldEl'));
			this.expiryField.useNativeValidation = false;
			this.expiryDate = '';
			this.expiryField.value = this.expiryDate;
		},

		checkNumber(){
			this.issueValue = this.issueValue.replace(/[^0-9]/g,'')
			this.expiryValue = this.expiryValue.replace(/[^0-9]/g,'')
		},

		selectImage(){
			this.$router.push('/licenseImageModify');
		},

		uploadFile(evt) {

			if (!evt.target.files[0]) return;
			this.$showLoading();
				const file = evt.target.files[0];
				const reader = new FileReader();
				reader.onload = (event) => {
				this.imgSrc = event.target.result;
				this.uploadImage(this.imgSrc)
				};
				reader.readAsDataURL(file);
		},

		uploadImage(img){
            let blob = this.dataURItoBlob(img);
            let formData = new FormData();
            formData.append('file', blob, 'license.png');

			httpService.upload(formData).then((response) => {
				this.image = response.data.data[0];
				this.$hideLoading();

			})
			.catch((err) => {
				console.log(err);
			});
		},

		openFileUpload(allowImg,type) {
			this.uploadTypeImg = allowImg;
			this.type = type
			setTimeout(() => {
				document.getElementById("commentFileUpload").click();
			}, 0);
		},

		allowExt() {
			return this.type ? "image/jpeg,image/png" : "image/jpeg,image/png";
		},

    removeLiencesImage() {
			this.image=null
		},

		dataURItoBlob(dataURI) {
			// convert base64/URLEncoded data component to raw binary data held in a string
			let byteString
			if (dataURI.split(',')[0].indexOf('base64') >= 0){
				byteString = atob(dataURI.split(',')[1])
			} else {
				byteString = unescape(dataURI.split(',')[1])
			}

			// separate out the mime component
			let mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];

			// write the bytes of the string to a typed array
			let ia = new Uint8Array(byteString.length);
			for (let i = 0; i < byteString.length; i++) {
				ia[i] = byteString.charCodeAt(i);
			}

			return new Blob([ia], {type:mimeString});
		},

		getMemberId() {
			memberApi.getMemberInfo().then((response) => {

				this.memberId = response.data.data.id;
				this.memberName = response.data.data.name.fullName;

				let params = {
					"memberId":this.memberId
				};
				this.getLicenseResponsibility(params);
			}).catch((err) => {
				console.log(err);
			});
		},
		getLicenseResponsibility(params) {
			licenseApi.getLicenseResponsibility(params).then((response)=>{
				this.useValidity = response.data.data.useValidPeriod;
				this.licenseName = response.data.data.name;
				this.licenseId = response.data.data.id;

				let params = {
					memberId: this.memberId
				};
				this.getLicenseInfo(params);
			}).catch((err)=>{
				console.log(err);
			});
		},
		getLicenseInfo(params) {
			licenseApi.getMemberLicenseDetails(params).then((response) => {

				Date.prototype.yyyymmdd = function() {
					var mm = this.getMonth() + 1;
					var dd = this.getDate();

					return [
						this.getFullYear(),
						(mm>9 ? '' : '0') + mm,
						(dd>9 ? '' : '0') + dd
					].join('');
				};

				this.id = response.data.data.licenseMember.id;

				let issueD = new Date(response.data.data.licenseMember.issueDate);
				this.issueValue = issueD.yyyymmdd();

				let expiryD = new Date(response.data.data.licenseMember.expiryDate);
				this.expiryValue = expiryD.yyyymmdd();;
				if(this.tempImage) {
					this.image = this.tempImage;
				} else {
					if(response.data.data.licenseMember.file){
						this.imagePreview = response.data.data.licenseMember.file.resourceUri;
						this.image = response.data.data.licenseMember.file;
					} else {
						this.imagePreview = "images/thumbnail.png";
					}
				}


				this.licenseId = response.data.data.licenseResponsibility.id;
				this.licenseName = response.data.data.licenseResponsibility.name;

				this.memberId = response.data.data.member.id;
				this.memberName = response.data.data.member.name;
			//	this.$refs.expiryDate.focus();

				this.$refs.issueDate.focus();
				$("#expiryFieldEl .mdc-floating-label").addClass("mdc-floating-label--float-above");
				$("#expiryFieldEl .mdc-notched-outline--upgraded").addClass("mdc-notched-outline--notched");
				$("#expiryFieldEl .mdc-notched-outline__notch").css("width", "88.25px");
			}).catch((err) => {
				console.log(err);
			});
		},
		getTimeStamp(date) {
			if(date){
				let year = date.substring(0,4);
				let month = date.substring(4,6);
				let day = date.substring(6,8);
				let timeStamp = new Date(year, month - 1, day).getTime();
				return timeStamp;
			} else {
				return null;
			}
		},
		validateForm() {
			// check if image is available
			if(this.image == null){
				this.$snackOpen({
					contents: this.$t('1338'),
					btnDisplayYN: false,
					btnDisplay: '',
					timeoutMs: 4000
				}).then(() => { });
				return false;
			}

			this.$validator.validateAll().then((resultValid) => {
				this.submitState = true

				if (resultValid===true) {
					// add license
					this.modifyLicense();
				} else {
					this.focusFirstInvalidElement()
					return false
				}
			});
		},
		modifyLicense() {

			// this.image =JSON.parse(localStorage.getItem("licenseImage"));
			// console.log('this.image',this.image)
			let params = {
				"id" : this.id,
				"licenseResponsibility" : {
					"id" : this.licenseId,
					"name" : this.licenseName
				},
				"member" : {
					"id" : this.memberId,
					"name" : this.memberName
				},
				"issueDate" : this.getTimeStamp(this.issueValue),
				"expiryDate" : this.getTimeStamp(this.expiryValue),
				"file" : this.image
			}

			licenseApi.updateLicense(this.id, params).then((response)=>{
				localStorage.removeItem("licenseImage");
				this.$router.push('/viewLicense');
			}).catch((error) => {
				console.log(error);
			});
		}
	},

	computed: {
		validateIssueDate() {
			let returnValue = false;
			if (this.submitState) {
				if (this.errors.has('issueDate')) {
					returnValue = true;
					this.issueIcon = 'report_problem';
				} else {
					returnValue = false;
					this.issueIcon = 'check';
				}
			}

			this.issueField.valid === !returnValue ? '' : this.issueField.valid = !returnValue;
			return returnValue;
		},
		validateExpiryDate() {

			if(this.useValidity){
				let returnValue = false;
				if (this.submitState) {
					if (this.errors.has('expiryDate')) {
						returnValue = true;
						this.expiryIcon = 'report_problem';
					} else {
						returnValue = false;
						this.expiryIcon = 'check';
					}
				}
				this.expiryField.valid === !returnValue ? '' : this.expiryField.valid = !returnValue;
				return returnValue;
			}
		}
	}
};
</script>
<style scoped>
	.mdc-text-field--outlined.textFieldVal:not(.mdc-text-field--disabled) .mdc-notched-outline__leading, .mdc-text-field--outlined.textFieldVal:not(.mdc-text-field--disabled) .mdc-notched-outline__notch, .mdc-text-field--outlined.textFieldVal:not(.mdc-text-field--disabled) .mdc-notched-outline__trailing{
		border-color: var(--Textfeildactive) !important;

	}
</style>
